import React, { Component } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Alert,
  Spinner,
} from "reactstrap";
import { ActionResponse, UserService } from "../generated";
import { fetchJson } from "./shared/fetchJson";

export interface State {
  loading: boolean;
  success: boolean;
  error: any;
  logged: boolean;
}

export class TesterOutcomeUpload extends Component<{}, State> {
  constructor(props: {}) {
    super(props);

    this.state = {
      loading: true,
      success: null,
      error: null,
      logged: false,
    };

    this.submit = this.submit.bind(this);
  }

  async componentDidMount() {
    try {
      const r = await UserService.userUserExists();

      this.setState({
        logged: r,
      });
    } catch {
      this.setState({
        loading: false,
      });
    }
  }

  async submit(event: React.FormEvent<HTMLFormElement>) {
    this.setState({
      loading: true,
    });

    event.preventDefault();
    const data = new FormData(event.target as HTMLFormElement);

    //needs to be left with fetchJson instead of `OutcomeService`
    //as form data is not properly supported
    const r = await fetchJson<ActionResponse>("/api/outcome", {
      method: "POST",
      body: data,
    });

    this.setState({
      loading: false,
    });
    if (r.success) {
      this.setState({
        success: r.success,
      });
    } else {
      this.setState({
        error: r,
      });
    }

    return false;
  }

  render() {
    return !this.state.logged ? (
      <></>
    ) : (
      <div>
        <Modal
          isOpen={this.state.error != null}
          toggle={() => this.setState({ error: null })}
        >
          <ModalHeader>
            {this.state.error && this.state.error.title}
          </ModalHeader>
          <ModalBody>
            {this.state.error && JSON.stringify(this.state.error, null, 4)}
          </ModalBody>
        </Modal>
        <Alert>
          <p>You can now upload video of the outcome of the test.</p>
          <hr />
          <p>First choose the file and then click the upload button.</p>
          <Form onSubmit={this.submit} encType="multipart/form-data">
            <Input className="mb-3" name="outcomeVideo" type="file" />
            <Button color="success">Upload video</Button>

            {this.state.loading && <Spinner />}

            {this.state.success && "Video successfully uploaded"}
          </Form>
        </Alert>
      </div>
    );
  }
}
